import { WorklistValues } from "features/WorklistTools/shared/interfaces";
import { Alert, AlertType } from "shared-components/toast";
import {
  DestPlateInfoState,
  Twelve24TCToolActions,
  WorklistValuesState,
} from "../../state";
import { errorPRVDivDestWell, topupCalc } from "../../Twelve24TCToolHelpers";

export const addDestinationWellMapping = (
  dispatch: (action: { type: string; payload: any }) => void,
  sourcePlateIndex: number,
  wellMapping: WorklistValues[],
  destPlateInfo: DestPlateInfoState[],
  worklistValues: WorklistValuesState,
  destSelection: any,
  isStamping: boolean,
  methodSettings: any
) => {
  if (errorPRVDivDestWell(worklistValues, methodSettings, wellMapping)) {
    Alert({
      type: AlertType.ERROR,
      message: errorPRVDivDestWell(worklistValues, methodSettings, wellMapping),
    });
    return;
  }

  if (topupCalc(worklistValues, methodSettings, destPlateInfo, wellMapping)) {
    Alert({
      type: AlertType.ERROR,
      message: topupCalc(
        worklistValues,
        methodSettings,
        destPlateInfo,
        wellMapping
      ),
    });
    return;
  }
  dispatch(
    Twelve24TCToolActions.SOURCE_TO_DEST_ADDED({
      index: sourcePlateIndex,
      selections: wellMapping,
    })
  );
};
